import React, { useState, useEffect } from "react";
import { Modal, Table, Checkbox, Button, message, Spin } from "antd";
import axiosInstance from "../../configs";

const PermissionMatrix = ({ visible, onClose, role }) => {
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (role && visible) {
            fetchPermissions();
        }
    }, [role, visible]);

    const fetchPermissions = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`/roles/permissions/${role.id_user_level}`);
            setPermissions(res.data);
        } catch (err) {
            console.error(err);
            message.error("Gagal memuat permission");
        } finally {
            setLoading(false);
        }
    };

    const handleCheck = (id_menu, field, checked) => {
        setPermissions(prev => prev.map(p => {
            if (p.id_menu === id_menu) {
                return { ...p, [field]: checked ? 1 : 0 };
            }
            return p;
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                id_user_level: role.id_user_level,
                permissions: permissions.map(p => ({
                    id_menu: p.id_menu,
                    can_create: p.can_create,
                    can_read: p.can_read,
                    can_update: p.can_update,
                    can_delete: p.can_delete
                }))
            };

            await axiosInstance.post("/roles/permissions", payload);
            message.success("Permission berhasil disimpan");
            onClose();
        } catch (err) {
            console.error(err);
            message.error("Gagal menyimpan permission");
        } finally {
            setSaving(false);
        }
    };

    const columns = [
        {
            title: "Module / Menu",
            dataIndex: "label",
            key: "label",
            width: "30%"
        },
        {
            title: "Create",
            key: "can_create",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={!!record.can_create}
                    onChange={e => handleCheck(record.id_menu, 'can_create', e.target.checked)}
                />
            )
        },
        {
            title: "Read",
            key: "can_read",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={!!record.can_read}
                    onChange={e => handleCheck(record.id_menu, 'can_read', e.target.checked)}
                />
            )
        },
        {
            title: "Update",
            key: "can_update",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={!!record.can_update}
                    onChange={e => handleCheck(record.id_menu, 'can_update', e.target.checked)}
                />
            )
        },
        {
            title: "Delete",
            key: "can_delete",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={!!record.can_delete}
                    onChange={e => handleCheck(record.id_menu, 'can_delete', e.target.checked)}
                />
            )
        }
    ];

    return (
        <Modal
            title={`Akses Role: ${role?.user_level}`}
            visible={visible}
            onCancel={onClose}
            width={800}
            footer={[
                <Button key="cancel" onClick={onClose}>Batal</Button>,
                <Button key="save" type="primary" loading={saving} onClick={handleSave}>Simpan</Button>
            ]}
        >
            <Spin spinning={loading}>
                <Table
                    dataSource={permissions}
                    columns={columns}
                    rowKey="id_menu"
                    pagination={false}
                    size="small"
                    scroll={{ y: 400 }}
                />
            </Spin>
        </Modal>
    );
};

export default PermissionMatrix;
